import React, { useState, useEffect } from 'react'
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import PhoneInput from 'react-phone-input-2'
import Form from 'react-bootstrap/Form';
import LoadingAlert from '../Alerts/LoadingAlert';
import ErrorAlert from '../Alerts/ErrorAlert';
import { ClientsFetchAPI } from '../../api/Clients';
import { authenticationDgi } from '../../utils/AuthDgi';
import { normalizeClient } from '../../utils/ownershipContext';
import { useTranslation } from 'react-i18next';

const EditUserInfo = ({ modalUserUpdate, setModalUserUpdate, recoveryPasss, setParentClientInfo }) => {

    const { t } = useTranslation();

    const client = localStorage.getItem('client') && recoveryPasss == false ? JSON.parse(localStorage.getItem('client')) : {};

    const [name, setName] = useState(client.name || '');
    const [phone, setPhone] = useState(client.phone || '');
    const [nickName, setNickName] = useState(client.nickname || '');
    const [email, setEmail] = useState(client.email || '');
    const [Ruc, setRuc] = useState(client.ruc || '');
    const [Dv, setDv] = useState(client.dv || '');
    const [password, setPassword] = useState('')

    const [passwordCheck, setPasswordCheck] = useState('')
    const [codeInput, setCodeInput] = useState(false)
    const [codeValidInput, setCodeValidInput] = useState("")
    const [alertpass, setAlertpass] = useState("")
    const [alertValidPass, setAlertValidPass] = useState([])
    const [changePass, setChangePass] = useState(false)

    const [passwordRecoveryToken, setPasswordRecoveryToken] = useState("")

    const [clientInfo, setClientInfo] = useState(() => {
        if (localStorage.getItem('client') != null && localStorage.getItem('client') != undefined && localStorage.getItem('client') != '') {
            return JSON.parse(localStorage.getItem('client'))
        } else {
            return 0
        }
    })

    const cleanInputs = () => {
        if (recoveryPasss == false) {
            setName('')
            setPhone('')
            setNickName('')
            setPassword('')
            setPasswordCheck('')
            setEmail('')
        }

        setModalUserUpdate(false)
        setCodeInput(false)
        setCodeValidInput("")
        setChangePass(false)
        setPasswordRecoveryToken("")
    }

    const getApiError = (err, fallback) => {
        return err?.response?.data?.error || err?.response?.data?.message || fallback
    }

    const getPasswordRecoveryBaseData = () => {
        let business = JSON.parse(localStorage.getItem('business') || '{}')
        return {
            email,
            business_code: business.code,
            business_id: business.id,
        }
    }

    const verificationCode = async () => {
        const otp = codeValidInput.trim()

        if (!otp) {
            ErrorAlert('', t('profile.editUserInfo.enterCode'), 'error')
            return
        }

        LoadingAlert(t('profile.editUserInfo.verifyingCode'))
 
        try {
            const response = await ClientsFetchAPI.verifyPasswordRecovery({
                ...getPasswordRecoveryBaseData(),
                otp,
            })
            const responseData = response?.data?.data || response?.data || {}
            setPasswordRecoveryToken(responseData.recovery_token || responseData.recoveryToken || responseData.token || "")
            setCodeValidInput("")
            setCodeInput(false)
            setChangePass(true)
            ErrorAlert('', t('profile.editUserInfo.codeVerifiedSuccess'), 'success')
            return
        } catch (err) {
            ErrorAlert('', getApiError(err, t('profile.editUserInfo.invalidCode')), 'error')
            return
        }
    }


    const editUser = async () => {
        LoadingAlert(t('profile.editUserInfo.editingUser'))
        let token = undefined
        let business = JSON.parse(localStorage.getItem('business'))

        const authDgi1 = await authenticationDgi(Ruc)


        let data = {};
        if (changePass == true) {
            data.password = password;
            data.passwordCheck = passwordCheck;
        }

        if (recoveryPasss == false) {
            if (name !== clientInfo.name) data.name = name;
            if (phone !== clientInfo.phone) data.phone = phone;
            if (Ruc !== clientInfo.ruc) data.ruc = Ruc;
            if (Dv !== clientInfo.dv) data.dv = Dv;
        }
        if (email !== clientInfo.email) data.email = email;


        // Estos campos siempre se envían
        data.business_code = business.code;

        if (authDgi1.billing_name) {
            data.billing_name = authDgi1.billing_name;
            data.client_type_id = authDgi1.clientType;
            data.dv = authDgi1.dv;
            data.client_ruc_type = authDgi1.typeRuc;
        }


        try {
            const response = await ClientsFetchAPI.updateCurrentClient(data, token)
            ErrorAlert('', t('profile.editUserInfo.updateSuccess'), 'success')
            if (recoveryPasss == false) { getClientById() }
            cleanInputs()
        } catch (err) {
            setCodeInput(false)
            ErrorAlert('', err.response.data ? err.response.data.error : t('profile.errors.createUserError'), 'error')
            //console.log(err)
        }

    }
    const requestPasswordRecovery = async () => {
      
        try {
            LoadingAlert(t('profile.editUserInfo.requestingRecovery'))
            await ClientsFetchAPI.requestPasswordRecovery(getPasswordRecoveryBaseData())
            setCodeInput(true)
            setCodeValidInput("")
            setPasswordRecoveryToken("")
            ErrorAlert('', t('profile.editUserInfo.codeSentToEmail', { email }), 'success')
        } catch (err) {
            setCodeInput(false)
            ErrorAlert('', getApiError(err, t('profile.editUserInfo.requestRecoveryError')), 'error')
        }
    }

    const resetPassword = async () => {
        if (!changePass) {
            ErrorAlert('', t('profile.editUserInfo.verifyCodeFirst'), 'error')
            return
        }

        let token = undefined
        let data = {
            ...getPasswordRecoveryBaseData(),
            password,
            passwordCheck,
        }

        if (passwordRecoveryToken) {
            data.recovery_token = passwordRecoveryToken
        }

        try {
            LoadingAlert(t('profile.editUserInfo.updatingPassword'))
            await ClientsFetchAPI.resetPasswordRecovery(data, token)
            ErrorAlert('', t('profile.editUserInfo.passwordUpdateSuccess'), 'success')
            cleanInputs()
        } catch (err) {
            ErrorAlert('', getApiError(err, t('profile.editUserInfo.passwordUpdateError')), 'error')
        }
    }

    const handleValidRepitpass = (value) => {
        if (password !== value) {
            setAlertpass(t('profile.shared.passwordMismatch'))
        } else {
            setAlertpass(t('profile.shared.allSet'))
        }
    }

    const validatePassword = (value) => {
        let errors = [];
        if (value.length < 8 || value.length > 14) {
            errors.push(t('profile.shared.pwdRuleLength'));
        }
        if (!/[a-z]/.test(value)) {
            errors.push(t('profile.shared.pwdRuleLowercase'));
        }
        if (!/[A-Z]/.test(value)) {
            errors.push(t('profile.shared.pwdRuleUppercase'));
        }
        if (!/[!@#$%^&*(),.?":{}|<>_\-+=/\\[\]]/.test(value)) {
            errors.push(t('profile.shared.pwdRuleSymbol'));
        }
        if (/\s/.test(value)) {
            errors.push(t('profile.shared.pwdRuleNoSpaces'));
        } else if (errors.length === 0) {
            errors.push(t('profile.shared.pwdRuleValid'))
        }

        setAlertValidPass(errors)

    };

    const [showPassword, setShowPassword] = useState('')
    const toogglePasword = () => {
        setShowPassword(!showPassword);
    }



    const getClientById = async () => {
        try {
            let token = undefined
            const response = await ClientsFetchAPI.getCurrentClient(token);
            let jsonClient = normalizeClient(response.data);

            //function handleClientChange() {
            if (jsonClient?.id) {
                localStorage.setItem('client', JSON.stringify(jsonClient))
                localStorage.setItem('guestClient', 0)
                setClientInfo(jsonClient)
                if (setParentClientInfo) {
                    setParentClientInfo(jsonClient)
                }
            }
        } catch (err) {
            //console.log(err);
        }
    }

    /* ══════════════════════════════════════════
   ICONS
══════════════════════════════════════════ */
    const Ico = ({ d, size = 13 }) => (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
            stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            {d}
        </svg>
    );
    const IcoLock = () => <Ico d={<><rect x="3" y="11" width="18" height="11" rx="2" ry="2" /><path d="M7 11V7a5 5 0 0 1 10 0v4" /></>} />;
    const IcoUser = () => <Ico d={<><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" /><circle cx="12" cy="7" r="4" /></>} />;
    const IcoMail = () => <Ico d={<><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" /><polyline points="22,6 12,13 2,6" /></>} />;
    const IcoPhone = () => <Ico d={<><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.72 12a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.63 1.2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.82a16 16 0 0 0 6 6l1.18-1.18a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z" /></>} />;
    const IcoKey = () => <Ico d={<><path d="M21 2l-2 2m-7.61 7.61a5.5 5.5 0 1 1-7.778 7.778 5.5 5.5 0 0 1 7.777-7.777zm0 0L15.5 7.5m0 0l3 3L22 7l-3-3m-3.5 3.5L19 4" /></>} />;
    const IcoEdit = () => <Ico d={<><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" /><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" /></>} />;
    const IcoCheck = () => <Ico size={11} d={<polyline points="20 6 9 17 4 12" />} />;
    const IcoX = () => <Ico size={11} d={<><line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" /></>} />;
    const IcoShield = () => <Ico d={<><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" /></>} />;
    const IcoRefresh = () => <Ico d={<><polyline points="23 4 23 10 17 10" /><path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10" /></>} />;
    const eyebrow = recoveryPasss ? t('profile.editUserInfo.eyebrowAccount') : t('profile.editUserInfo.eyebrowProfile');
    const title = recoveryPasss ? t('profile.editUserInfo.titleRecoverPassword') : t('profile.editUserInfo.titleEditData');

    //Use effects to  fill the form with the client info when the modal is opened, only if it's not in recovery password mode (recoveryPasss == false)
    useEffect(() => {
        if (modalUserUpdate && recoveryPasss === false) {
            const storedClient = localStorage.getItem('client')
                ? JSON.parse(localStorage.getItem('client'))
                : {};

            setName(storedClient.name || '');
            setPhone(storedClient.phone || '');
            setNickName(storedClient.nickname || '');
            setEmail(storedClient.email || '');
            setRuc(storedClient.ruc || '');
            setDv(storedClient.dv || '');
            setClientInfo(storedClient || 0);
        }
    }, [modalUserUpdate, recoveryPasss]);
    return (
        <>
            <Modal
                show={modalUserUpdate}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >

                <Modal.Body className='form-signin-sp'>
                    <div className="ue-root">


                        <div className="ue-card">
                            <div className="ue-strip" />

                            {/* ── Header ── */}
                            <div className="ue-header">
                                <p className="ue-header-eyebrow">{eyebrow}</p>
                                <h2 className="ue-header-title">{title}</h2>
                            </div>

                            {/* ── Body ── */}
                            <div className="ue-body">

                                {codeInput === false ? (
                                    <div className="ue-fields">

                                        {/* ══ Modo: cambiar contraseña ══ */}
                                        {changePass === true ? (
                                            <>
                                                <div className="ue-fields-row">

                                                    {/* Nueva contraseña */}
                                                    <div className="ue-field">
                                                        <label className="ue-label">
                                                            <IcoLock /> {t('profile.shared.passwordLabel')}
                                                        </label>
                                                        <div className="ue-input-wrap">
                                                            <input
                                                                type={showPassword ? "text" : "password"}
                                                                className="ue-input"
                                                                placeholder="••••••••"
                                                                onChange={(e) => (setPassword(e.target.value), validatePassword(e.target.value))}
                                                            />
                                                        </div>
                                                        {alertValidPass.length > 0 && (
                                                            <div className="ue-validation">
                                                                {alertValidPass.map((alert, index) => (
                                                                    <span
                                                                        key={index}
                                                                        className={`ue-val-item ${alert === t('profile.shared.pwdRuleValid') ? "ok" : "err"}`}
                                                                    >
                                                                        {alert === t('profile.shared.pwdRuleValid') ? <IcoCheck /> : <IcoX />}
                                                                        {alert}
                                                                    </span>
                                                                ))}
                                                            </div>
                                                        )}
                                                    </div>

                                                    {/* Repetir contraseña */}
                                                    <div className="ue-field">
                                                        <label className="ue-label">
                                                            <IcoLock /> {t('profile.shared.repeatPasswordLabel')}
                                                        </label>
                                                        <input
                                                            type={showPassword ? "text" : "password"}
                                                            className="ue-input"
                                                            placeholder="••••••••"
                                                            onChange={(e) => (setPasswordCheck(e.target.value), handleValidRepitpass(e.target.value))}
                                                        />
                                                        {alertpass && (
                                                            <div className="ue-validation">
                                                                <span className={`ue-val-item ${alertpass === t('profile.shared.passwordMismatch') ? "err" : "ok"}`}>
                                                                    {alertpass === t('profile.shared.passwordMismatch') ? <IcoX /> : <IcoCheck />}
                                                                    {alertpass}
                                                                </span>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>

                                                {/* Mostrar contraseña */}
                                                <div className="ue-checkbox-row">
                                                    <input
                                                        className="ue-checkbox"
                                                        type="checkbox"
                                                        id="ue-show-pass"
                                                        onChange={() => toogglePasword()}
                                                    />
                                                    <label className="ue-checkbox-label" htmlFor="ue-show-pass">
                                                        {t('profile.shared.showPassword')}
                                                    </label>
                                                </div>
                                            </>

                                        ) : (
                                            <>
                                                {/* ══ Modo: recuperar contraseña (solo email) ══ */}
                                                {recoveryPasss === true ? (
                                                    <div className="ue-field">
                                                        <label className="ue-label">
                                                            <IcoMail /> {t('profile.shared.emailLabel')}
                                                        </label>
                                                        <input
                                                            type="text"
                                                            className="ue-input"
                                                            placeholder={t('profile.shared.emailPlaceholder')}
                                                            value={email}
                                                            onChange={(e) => setEmail(e.target.value)}
                                                        />
                                                    </div>

                                                ) : (
                                                    <>
                                                        {/* ══ Modo: editar datos generales ══ */}
                                                        <div className="ue-fields-row">
                                                            <div className="ue-field">
                                                                <label className="ue-label">
                                                                    <IcoUser /> {t('profile.shared.fullNameLabel')}
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    value={name}
                                                                    className="ue-input"
                                                                    placeholder={t('profile.editUserInfo.fullNamePlaceholder')}
                                                                    onChange={(e) => setName(e.target.value)}
                                                                />
                                                            </div>

                                                            <div className="ue-field">
                                                                <label className="ue-label">
                                                                    <IcoMail /> {t('profile.shared.emailLabel')}
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    className="ue-input"
                                                                    placeholder={t('profile.shared.emailPlaceholder')}
                                                                    value={email}
                                                                    onChange={(e) => setEmail(e.target.value)}
                                                                />
                                                            </div>
                                                        </div>

                                                        {/* Teléfono */}
                                                        <div className="ue-field">
                                                            <label className="ue-label">
                                                                <IcoPhone /> {t('profile.shared.phoneLabel')}
                                                            </label>
                                                            <Form.Group controlId="phone2" style={{ marginBottom: 0 }}>
                                                                <PhoneInput
                                                                    country={"pa"}
                                                                    value={phone}
                                                                    onChange={(p) => setPhone(p)}
                                                                    inputProps={{ name: "phone2", required: true, autoFocus: true }}
                                                                    countryCodeEditable={false}
                                                                    enableSearch
                                                                />
                                                            </Form.Group>
                                                        </div>

                                                        {/* RUC / DV — collapsible */}
                                                        <div className="ue-field">
                                                            <details className="ue-details">
                                                                <summary className="ue-summary">
                                                                    <IcoEdit /> {t('profile.shared.rucDvLabel')}
                                                                    <span style={{ fontSize: "0.7rem", color: "var(--ink-3)", fontWeight: 400, marginLeft: 4 }}>
                                                                        {t('profile.editUserInfo.optionalLabel')}
                                                                    </span>
                                                                </summary>
                                                                <div className="ue-ruc-grid">
                                                                    <div className="ue-field">
                                                                        <label className="ue-label">{t('profile.shared.rucNumberLabel')}</label>
                                                                        <input
                                                                            type="text"
                                                                            className="ue-input"
                                                                            placeholder="0-0000-0"
                                                                            value={Ruc}
                                                                            onChange={(e) => setRuc(e.target.value)}
                                                                        />
                                                                    </div>
                                                                    <div className="ue-field">
                                                                        <label className="ue-label">{t('profile.shared.dvNumberLabel')}</label>
                                                                        <input
                                                                            type="number"
                                                                            className="ue-input"
                                                                            placeholder="00"
                                                                            value={Dv}
                                                                            onChange={(e) => setDv(e.target.value)}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </details>
                                                        </div>
                                                    </>
                                                )}
                                            </>
                                        )}

                                    </div>

                                ) : (
                                    /* ══ Modo: código de verificación ══ */
                                    <div className="ue-code-block">
                                        <div className="ue-code-hint">
                                            <span className="ue-code-hint-icon"><IcoKey size={16} /></span>
                                            {t('profile.editUserInfo.codeHint')}
                                        </div>
                                        <input
                                            type="text"
                                            className="ue-code-input"
                                            placeholder="0000"
                                            value={codeValidInput}
                                            onChange={(e) => setCodeValidInput(e.target.value)}
                                        />
                                    </div>
                                )}

                            </div>

                            {/* ── Footer: acciones ── */}
                            <div className="ue-footer">

                                {/* Cancelar — siempre a la izquierda */}
                                {codeInput === false ? (
                                    <button className="ue-btn ue-btn-danger" onClick={cleanInputs}>
                                        {t('common.cancel')}
                                    </button>
                                ) : (
                                    <button className="ue-btn ue-btn-danger" onClick={() => setCodeInput(false)}>
                                        {t('common.cancel')}
                                    </button>
                                )}

                                {/* Acciones primarias — derecha */}
                                <div className="ue-footer-right">

                                    {codeInput === false ? (
                                        <>
                                            {changePass === false ? (
                                                <>
                                                    {recoveryPasss === true ? (
                                                        <button className="ue-btn ue-btn-primary" onClick={() => requestPasswordRecovery()}>
                                                            <IcoShield /> {t('profile.editUserInfo.recoverPasswordBtn')}
                                                        </button>
                                                    ) : (
                                                        <>
                                                            <button className="ue-btn ue-btn-ghost" onClick={() => requestPasswordRecovery()}>
                                                                <IcoLock /> {t('profile.editUserInfo.changePasswordBtn')}
                                                            </button>
                                                            <button className="ue-btn ue-btn-primary" onClick={() => editUser()}>
                                                                {t('profile.editUserInfo.saveChanges')}
                                                            </button>
                                                        </>
                                                    )}
                                                </>
                                            ) : (
                                                <>
                                                    {recoveryPasss === true && (
                                                        <button className="ue-btn ue-btn-primary" onClick={() => resetPassword()}>
                                                            <IcoLock /> {t('profile.editUserInfo.savePassword')}
                                                        </button>
                                                    )}
                                                </>
                                            )}

                                            {recoveryPasss === false && changePass === false && (
                                                <></>
                                                /* El botón "Continuar" ya está cubierto por "Guardar cambios" arriba */
                                            )}
                                        </>
                                    ) : (
                                        <button className="ue-btn ue-btn-primary" onClick={() => verificationCode()}>
                                            <IcoCheck /> {t('profile.editUserInfo.verifyCode')}
                                        </button>
                                    )}

                                </div>
                            </div>

                        </div>
                    </div>



                </Modal.Body>
            </Modal>
        </>
    )
}

export default EditUserInfo
